import * as DE from './de';

export default {
  'de': {
    views: DE.Views
  }
};

